import styled from '@emotion/styled'
import { Text, Box } from 'theme-ui'

import { WithTheme } from './../../../setup/index'
import { transition } from './../../../common/Mixins'
import media from '../../../common/MediaQueries'

const ContactBlockStyled = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column-reverse;

  @media ${media.tablet} {
    flex-direction: row;
  }
`

const ContactBlockContentStyled = styled.div``

const ContactBlockFormStyled = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 5.75rem;
  @media ${media.tablet} {
    margin-bottom: 0;
    flex-grow: 1;
    justify-content: flex-end;
    padding-left: 4rem;
  }
`

const ContactBlockContentHeadStyled = styled.div`
  margin-bottom: 50px;

  @media ${media.tablet} {
    margin-bottom: 80px;
  }
`

const ContactBlockContentHeadTextStyled = styled(Text)<WithTheme>`
  font-size: 25px;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  font-family: ${({ theme }) => theme.fonts.secondary};

  @media ${media.maxTablet} {
    text-align: center;
  }

  @media ${media.tablet} {
    font-size: 30px;
  }
`

const ContactBlockContentIconsStyled = styled.div`
  display: inline-flex;
  flex-direction: column;
  margin-bottom: 80px;
  @media ${media.tablet} {
    margin-bottom: 100px;
  }
`

const ContactBlockContentSocialStyled = styled.div``

const ContactBlockContentIconsItemStyled = styled(Box)`
  ${transition}
  display: flex;
  cursor: pointer;
  &:not(:last-child) {
    margin-bottom: 80px;
  }

  &:hover {
    opacity: 0.8;
  }
`

export {
  ContactBlockStyled,
  ContactBlockContentStyled,
  ContactBlockFormStyled,
  ContactBlockContentHeadStyled,
  ContactBlockContentHeadTextStyled,
  ContactBlockContentIconsStyled,
  ContactBlockContentSocialStyled,
  ContactBlockContentIconsItemStyled
}
